import { call, delay, put, takeLatest } from "redux-saga/effects";
import { toast } from "react-toastify";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";
import { VasRateActionTypes, VasRateActions } from "../../../actionTypes/master/vasRateActionTypes";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";
import {
  createVasRateApi,
  editVasRateDataByIdApi,
  getVasRateDataByIdApi,
  getVasRateListApi,
} from "../../requests/master/vasRateRequests";
import {
  getVasRateList,
  setVasRateDataById,
  setVasRateList,
  setVasRateListPageCount,
} from "../../../actions/master/vasRateActions";


function* createVasRateHandler(action: VasRateActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createVasRateApi, action.payload);

    if (data.status) {
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getVasRateListHandler(action: VasRateActionTypes) {
  yield delay(500);
  try {
    yield startLoader("transparent");

    const { data } = yield call(getVasRateListApi, action.payload);

    if (data.status) {
      yield put(setVasRateList(data?.data?.rows ?? []));
      yield put(setVasRateListPageCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getVasRateDataByIdHandler(action: VasRateActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getVasRateDataByIdApi, action.payload);
    if (data.status) {
      yield put(setVasRateDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editVasRateDataByIdHandler(action: VasRateActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(editVasRateDataByIdApi, action.payload);
    if (data.status) {
      toast.success(data.message, {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getVasRateList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

export default function* vasRateSaga() {
  yield takeLatest(VasRateActions.CREATE_VAS_RATE, createVasRateHandler);
  yield takeLatest(VasRateActions.GET_VAS_RATE_LIST, getVasRateListHandler);
  yield takeLatest(VasRateActions.GET_VAS_RATE_DATA_BY_ID, getVasRateDataByIdHandler);
  yield takeLatest(VasRateActions.EDIT_VAS_RATE_DATA_BY_ID, editVasRateDataByIdHandler);
}
